import { useEffect, useState } from "react";
import { rfpApi } from "@/lib/api-client";
import { Target } from "lucide-react";

export const WinRateMonitor = ({ refreshKey }) => {
  const [data, setData] = useState(null);

  useEffect(() => {
    rfpApi.winRate().then(setData).catch(() => {});
  }, [refreshKey]);

  const styles = data?.styles || [];
  return (
    <section className="border border-emerald-500/25 bg-emerald-500/[0.03] px-4 py-3 mb-4" data-testid="win-rate-monitor">
      <div className="flex items-center gap-2 mb-2">
        <Target size={11} className="text-emerald-300" />
        <span className="font-mono-uc text-[10px] uppercase tracking-widest text-emerald-300">
          Win-Rate Monitor · self-healing pitch strategy
        </span>
        {data?.leader && (
          <span className="ml-auto font-mono-uc text-[9px] uppercase tracking-widest px-1.5 py-0.5 border border-emerald-500/50 text-emerald-300"
                data-testid="win-rate-leader">
            Leader: {data.leader}
          </span>
        )}
      </div>
      <div className="grid grid-cols-1 sm:grid-cols-3 gap-2">
        {styles.map((s) => (
          <div key={s.style} data-testid={`win-rate-style-${s.style}`}
               className={`border px-2.5 py-2 ${data?.leader === s.style ? "border-emerald-500/50 bg-emerald-500/[0.05]" : "border-white/10 bg-black/40"}`}>
            <div className="font-mono-uc text-[9px] uppercase tracking-widest text-white/60">{s.style}</div>
            <div className="flex items-baseline gap-2 mt-1">
              <span className="font-serif-display text-lg text-white/90" data-testid={`win-rate-pct-${s.style}`}>
                {s.win_rate === null || s.win_rate === undefined ? "—" : `${Math.round(s.win_rate * 100)}%`}
              </span>
              <span className="font-mono-uc text-[8px] text-white/40">
                {s.bites} bite(s) / {s.sent} sent
              </span>
            </div>
          </div>
        ))}
      </div>
      <div className="font-mono-uc text-[8px] text-white/35 mt-1.5">{data?.basis || "bites / founder-signed proposals"}</div>
    </section>
  );
};
